"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Callout = void 0;
const core_1 = require("@material-ui/core");
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importStar(require("@opsbase/web-css"));
const DeleteIcon_1 = __importDefault(require("@opsbase/web-icons/icons/DeleteIcon"));
const EditIcon_1 = __importDefault(require("@opsbase/web-icons/icons/EditIcon"));
const ImageViewer_1 = __importDefault(require("@opsbase/web-image/ImageViewer"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Button_1 = require("@opsbase/web-ui/Button");
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importDefault(require("react"));
const makeMyClasses = (...props) => {
    return {
        container: {
            position: 'relative',
        },
        row: {
            paddingTop: 4,
            paddingBottom: 4,
            paddingLeft: 4,
        },
        content: {
            padding: '8px',
            wordBreak: 'break-word',
            whiteSpace: 'normal',
        },
        other: {
            marginRight: (props === null || props === void 0 ? void 0 : props[1]) ? 16 : '25%',
            marginLeft: (props === null || props === void 0 ? void 0 : props[1]) ? 16 : 0,
            borderLeft: `solid 2px ${lib_palette_1.default.InputBorderGrey.main}`,
            backgroundColor: (props === null || props === void 0 ? void 0 : props[0]) ? lib_palette_1.default.WhiteSmoke.main : undefined,
        },
        self: {
            marginLeft: (props === null || props === void 0 ? void 0 : props[1]) ? 16 : '25%',
            marginRight: (props === null || props === void 0 ? void 0 : props[1]) ? 16 : 0,
            borderRight: `solid 2px ${lib_palette_1.default.secondary.main}`,
            backgroundColor: (props === null || props === void 0 ? void 0 : props[0]) ? lib_palette_1.default.WhiteSmoke.main : undefined,
            textAlign: 'right',
        },
        editedText: {
            color: lib_palette_1.default.GreyBlue.main,
            fontSize: 12,
            paddingTop: 4,
            paddingLeft: 8,
        },
    };
};
function Callout(props) {
    const { variant, text, photos, onEditPress, onDeletePress, children, edited, fullSize } = props;
    const imageFileNames = photos ? photos === null || photos === void 0 ? void 0 : photos.split(',') : [];
    const myCss = (0, web_css_1.default)(makeMyClasses, [!!(text || photos), fullSize]);
    return (react_1.default.createElement(core_1.Grid, { className: (0, web_css_1.cx)(myCss.container, myCss[variant]) },
        react_1.default.createElement(Horizontal_1.default, { justify: 'flex-end', centered: true },
            edited ? react_1.default.createElement(Text_1.default, { className: myCss.editedText }, 'edited') : null,
            react_1.default.createElement(Pane_1.default, { grow: true }),
            onEditPress ? (react_1.default.createElement(Button_1.Button, { tiny: true, style: {
                    backgroundColor: lib_palette_1.default.White.main,
                    marginTop: 6,
                    marginRight: 8,
                }, onClick: onEditPress },
                react_1.default.createElement(EditIcon_1.default, { color: lib_palette_1.default.secondary, size: 15 }))) : null,
            onDeletePress ? (react_1.default.createElement(Button_1.Button, { tiny: true, style: {
                    backgroundColor: lib_palette_1.default.White.main,
                    marginTop: 6,
                    marginRight: 8,
                }, onClick: onDeletePress },
                react_1.default.createElement(DeleteIcon_1.default, { color: lib_palette_1.default.secondary, size: 15 }))) : null),
        children ? react_1.default.createElement(core_1.Grid, { className: myCss.content }, children) : null,
        text ? react_1.default.createElement(Text_1.default, { className: myCss.content + ' Callout' }, text) : null,
        photos ? (react_1.default.createElement(core_1.Grid, { container: true, className: myCss.row, spacing: 0 }, imageFileNames ? react_1.default.createElement(ImageViewer_1.default, { fileNames: imageFileNames, size: 100 }) : null)) : null));
}
exports.Callout = Callout;
exports.default = Callout;
